import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import localeText from "../../../../../locale";

const UpgradePlanCard = ({
  planKey,
  planConfig,
  priceLabel,
  isHighlighted,
  showMostPopular,
  selectable,
  loading,
  renewLabel,
  onSelect,
}) => {
  const featureKeys = planConfig.featureKeys || [];

  return (
    <article
      className={`upgrade-page-card border-round-lg ${isHighlighted ? "upgrade-page-card-highlighted" : ""}`}
      style={{
        backgroundColor: isHighlighted
          ? "var(--theme-secondary-dark, #20205f)"
          : "var(--theme-background, #ffffff)",
      }}
    >
      {showMostPopular && (
        <Tag
          className="upgrade-page-most-popular"
          value={localeText("upgradeMostPopular")}
          style={{
            backgroundColor: "var(--theme-background, #ffffff)",
            color: "var(--theme-primary, #28ab69)",
          }}
        />
      )}
      <div className="upgrade-page-card-header">
        <p
          className="upgrade-page-profile-label text-lg"
          style={{ color: isHighlighted ? "rgba(255,255,255,0.92)" : "var(--theme-text, #091e42)" }}
        >
          {localeText("profile")}
        </p>
        <h3
          className="upgrade-page-plan-title text-4xl font-bold"
          style={{
            color: isHighlighted
              ? "var(--theme-primary, #28ab69)"
              : "var(--theme-primary-dark, #208c56)",
          }}
        >
          {localeText(`upgradePlanName${planKey}`)}
        </h3>
        <Tag
          value={planConfig.tierLabel}
          className="upgrade-page-tier-tag"
          style={{
            backgroundColor:
              planKey === "Partner"
                ? "color-mix(in srgb, var(--theme-border, #EBEBEB) 30%, transparent)"
                : planKey === "Manager"
                  ? "#f8c83c"
                  : "var(--theme-primary, #28ab69)",
            color: planKey === "Manager" ? "#091e42" : "#ffffff",
          }}
        />
        <p
          className="upgrade-page-description text-sm"
          style={{
            color: isHighlighted ? "rgba(255,255,255,0.9)" : "var(--theme-text-muted, #7a869a)",
          }}
        >
          {localeText(`upgradePlanDescription${planKey}`)}
        </p>
      </div>

      <div className="upgrade-page-card-content">
        <ul className="upgrade-page-feature-list">
          {featureKeys.map((featureKey) => (
            <li key={featureKey}>
              <i className="pi pi-check" />
              <span className="font-medium">{localeText(featureKey)}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="upgrade-page-card-footer">
        {priceLabel && <p className="upgrade-page-card-price">{priceLabel}</p>}
        {renewLabel && <p className="upgrade-page-card-renew">{renewLabel}</p>}
        {selectable ? (
          <Button
            className={`upgrade-page-select-button border-round-md font-semibold ${isHighlighted ? "upgrade-page-select-button-highlighted" : ""}`}
            label={localeText("selectPlan")}
            onClick={onSelect}
            loading={loading}
          />
        ) : (
          <Button
            className="upgrade-page-select-button border-round-md font-semibold"
            label={localeText("comingSoon")}
            disabled={true}
          />
        )}
      </div>
    </article>
  );
};

export default UpgradePlanCard;
